export default class VistaprintAnalyticsService {
    /**
     * Records a Feature Value Touched event for the given Feature Id
     * @param {number} featureId - the FeatureId (not the feature value) for the feature that should be touched
     */
    static recordFeatureValueTouched(featureId) {
        fetch(`/studio4/touchfeaturevalue?featureId=${featureId}`, {
            method: 'GET',
            credentials: 'include', // send credential cookie with request
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/VistaprintAnalyticsService.js